import { Table } from 'antd';

import type { ModelSubscription } from '@app/api/Subscriptions';
import { ConfirmDeletingElement, Error403Unauthorized } from '@app/components';
import { useWindowSize } from '@app/hooks';
import { FiltersAccordion } from '@app/shared/components';

import { SubscriptionModal } from './components/SubscriptionModal';
import { SubscriptionsFilters } from './components/SubscriptionsFilters/SubscriptionsFilters';
import { SUBSCRIPTIONS_TABLE_SCROLL_X } from './data/constants';
import { useSubscriptions } from './hooks/useSubscriptions';
import { useSubscriptionsEffects } from './hooks/useSubscriptionsEffects';

import type { FC } from 'react';

import './styles/Subscriptions.scss';

export const Subscriptions: FC = () => {
  const {
    subscriptions,
    columns,
    isLoading,
    canView,
    unsavedSearchTerm,
    onChangeSearchTerm,
    onSearch,
    onReset,
    isModalOpen,
    editingSubscriptionId,
    openCreateModal,
    closeModal,
    setHeader,
    isDeleteModalOpen,
    deleteModalContent,
    isDeleting,
    setIsDeleteModalOpen,
    confirmDelete,
  } = useSubscriptions();

  useSubscriptionsEffects({ setHeader, openCreateModal });

  const { isMobile } = useWindowSize();

  if (!canView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="Subscriptions">
      <FiltersAccordion>
        <SubscriptionsFilters
          searchTerm={unsavedSearchTerm}
          onChangeSearchTerm={onChangeSearchTerm}
          onSearch={onSearch}
          onReset={onReset}
        />
      </FiltersAccordion>
      <Table<ModelSubscription>
        className="Subscriptions__table"
        columns={columns}
        dataSource={subscriptions}
        rowKey="Id"
        loading={isLoading}
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: SUBSCRIPTIONS_TABLE_SCROLL_X }}
        pagination={false}
      />
      <SubscriptionModal
        isOpen={isModalOpen}
        subscriptionId={editingSubscriptionId}
        onClose={closeModal}
      />
      <ConfirmDeletingElement
        modalOpen={isDeleteModalOpen}
        setModalOpen={setIsDeleteModalOpen}
        handleDelete={confirmDelete}
        content={deleteModalContent}
        title="Удаление абонемента"
        isStageDeletionLoading={isDeleting}
        modalDataTestId="delete-subscription-popup"
        titleDataTestId="delete-subscription-popup-title"
        descriptionDataTestId="delete-subscription-popup-description"
      />
    </div>
  );
};
